(function($){
    
	/* Document Ready */
	$(document).ready(function() {
        AOS.init({
            duration: 400,
            once: true,
        });
        
        objectFitImages();

        /* init Jarallax */
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__inner">';
                
                sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';
                
                if($('.site-header--phone').length){
                    sidrHtml += '<div class="sidr__phone">' + $('.site-header--phone').html() + '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                //alert('test');
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                $( '#mobile-trigger' ).addClass('active sidr__close');
//                $('.site-header').css('position','fixed');
                $('.site-header').css({
                    'position': 'fixed',
                    'top': '0',
                });
                
                var alertouterheight = $('.site-header').height();

                $( '#sidr' ).css({
                    "margin-top": alertouterheight + 'px',
                    "height": "calc(100% - " + alertouterheight + "px)"
                });

                $( '.sidr-overlay' ).css({
                    "margin-top": alertouterheight + 'px',
                    "height": "calc(100% - " + alertouterheight + "px)"
                });
                
                $( 'body' ).css({
                    "padding-top": alertouterheight + 'px',
                });
    //            
                $(window).resize(function() {
                    var alertouterheight = $('.site-header').height();

                    $( '#sidr' ).css({
                        "margin-top": alertouterheight + 'px',
                        "height": "calc(100% - " + alertouterheight + "px)"
                    });

                    $( '.sidr-overlay' ).css({
                        "margin-top": alertouterheight + 'px',
                        "height": "calc(100% - " + alertouterheight + "px)"
                    });
                    
                }).resize();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $( '#mobile-trigger' ).removeClass('active sidr__close');
                $('.site-header').css({
                    'position': 'relative',
                    'top': 'auto',
                });
                $( 'body' ).css({
                    "padding-top": '0px',
                });
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).prev().toggleClass('active');
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
        
        //Footer Quicklinks
        if($('.js-toggle-quicklinks').length){
            $('.js-toggle-quicklinks').click(function(e) {
                e.preventDefault();
                $(this).toggleClass('active').next().toggleClass('active');
            });
        }
        
	});
    
})(jQuery);